<template>
  <div>
    This is a great guide for Gorseval.
  </div>
</template>

<script>
export default {
  name: "Gorseval"
}
</script>

<style scoped>

</style>